/**
 * @constructor
 * @implements {Foundation.Login.ThirdPartyAuthenticator}
 */

 Foundation.Google.Authenticator = function (/* options */) {
  this._fdnMember = null
}

Foundation.Google.Authenticator.prototype.sessionManagerDelegateID = function () {
  return "google";
}

Foundation.Google.Authenticator.prototype.serviceName = function () {
  return "Google";
}

Foundation.Google.Authenticator.prototype.authenticateWithThirdPartyService = function () {
  // if(window.console) console.log('Foundation.Google.Authenticator.authenticateWithThirdPartyService')
  var result = new Foundation.Promise()
  Foundation.Google.authSignIn().then(function () {
    // if(window.console) console.log('Successful goog signin')
    result.fulfill()
  }.bind(this), function (response) {
    result.failWith(response)
  }.bind(this))
  return result
}

Foundation.Google.Authenticator.prototype.sessionTTL = function () {
  return 0
}

/* Used in ThirdPartyAuthenticationShepherd.js */
Foundation.Google.Authenticator.prototype.suggestedUserEmailAddress = function () {
  return Foundation.Google.userEmailAddress() || null
}
Foundation.Google.Authenticator.prototype.suggestedUserName = function () {
  return Foundation.Google.userName() || null
}
Foundation.Google.Authenticator.prototype.suggestedUserFullName = function () {
  return Foundation.Google.userName() || null
}

Foundation.Google.Authenticator.prototype.authenticateWithFoundation = function () {
  // if(window.console) console.log('Foundation.Google.Authenticator.authenticateWithFoundation')
  // if(window.console) console.log('id_token: '+Foundation.Google.googleIdToken())

  var result = new Foundation.Promise()
  var idToken = Foundation.Google.googleIdToken()
  var email = Foundation.Google.userEmailAddress()

  if (Foundation.Google.authSignedIn()) {
    this._fdnMember = new Foundation.API("GET", "Google/Member", {
      "idToken": idToken,
      "email": email
    })
    this._fdnMember.then(function () {
      if (this._fdnMember.get("isLikelyToCollide")) {
        return result.fail()
      }
      else {
        result.marry(this._fdnMember)
      }
    }.bind(this), function () {
      result.marry(this._fdnMember)
    }.bind(this))
  }
  else {
    result.failWith({"errors": [Foundation.Google.Authenticator._notLoggedInErrorMessage]})
  }
  return result
}

Foundation.Google.Authenticator.prototype.decorateMember = function (/* theMember */) {
  var done = new Foundation.Promise()
  done.fulfill()  // Nothing to do here
  return done
}

Foundation.Google.Authenticator.prototype.memberOid = function () {
  return (this._fdnMember.get("oid"))
}

Foundation.Google.Authenticator.prototype.memberUserName = function () {
  return (this._fdnMember.get("userName"))
}

Foundation.Google.Authenticator.prototype.memberAvatarUrl = function () {
  return (this._fdnMember.get("avatarUrl"))
}

Foundation.Google.Authenticator.prototype.accountIsLikelyToCollide = function () {
  return (this._fdnMember.get("isLikelyToCollide")) || false
}

Foundation.Google.Authenticator.prototype.linkLoggedInMemberWithThirdPartyCredentials = function () {
  // if(window.console) console.log('Foundation.Google.Authenticator.linkLoggedInMemberWithThirdPartyCredentials\nSigned in Google then to link account with Foundation')
  var result = new Foundation.Promise()
  if (Foundation.Google.authSignedIn()) {
    this._fdnMember = new Foundation.API("POST", "Google/Member", {
      "idToken": Foundation.Google.googleIdToken()
    })
  }
  else {
    // if(window.console) console.log('Account not linked with Google.')
    result.failWith({"errors": [Foundation.Google.Authenticator._notLoggedInErrorMessage]})
  }
  return result
}

Foundation.Google.Authenticator.prototype.userCanceledAccountCreation = function () {
  // if(window.console) console.log('Foundation.Google.Authenticator.userCanceledAccountCreation')
  Foundation.Google.disconnectFromFoundation()
  return Foundation.Google.cleanCookie()
}

Foundation.Google.Authenticator._notLoggedInErrorMessage = "User does not appear to be logged in with Google SignIn and connected to publication account."
